import { useState, useEffect } from "react";
import ContactsList from "../components/chats/ContactsList";
import MessagesPane from "../components/chats/MessagesPane";
import { useParams } from "react-router-dom";

const Chats = () => {
  const { "*": threadParam } = useParams();
  const [selectedContact, setSelectedContact] = useState(null);

  return (
    <div className="flex h-[90vh] bg-gray-100 rounded-lg shadow-lg overflow-hidden border border-gray-300">
      <ContactsList
        selectedThreadId={threadParam}
        onSelect={(c) => setSelectedContact(c)}
        selectedContact={selectedContact}
      />
      <MessagesPane contact={selectedContact} />
    </div>
  );
};

export default Chats;
